import { ADSTERRA } from "@/ads/adsterraConfig";
import { installPopunderGuard } from "@/ads/popunderGuard";

// Inserts raw HTML and re-creates <script> tags so the browser executes them.
export function injectHtml(code, target = document.body) {
  if (!code || !code.trim()) return;
  const tpl = document.createElement("template");
  tpl.innerHTML = code.trim();
  tpl.content.childNodes.forEach((node) => {
    if (node.nodeName === "SCRIPT") {
      const s = document.createElement("script");
      [...node.attributes].forEach((a) => s.setAttribute(a.name, a.value));
      s.text = node.textContent;
      s.dataset.adsterra = "1";
      target.appendChild(s);
    } else {
      target.appendChild(node.cloneNode(true));
    }
  });
}

let globalsLoaded = false;
const clearGlobals = () => document.querySelectorAll("body > script[data-adsterra]").forEach((n) => n.remove());

export function unloadGlobalAds() {
  clearGlobals();
  globalsLoaded = false;
}

export function loadGlobalAds() {
  if (globalsLoaded) return;
  globalsLoaded = true;
  installPopunderGuard();
  injectHtml(ADSTERRA.popunder);
  injectHtml(ADSTERRA.socialBar);
}

export function fireLockAd() {
  if (ADSTERRA.lockAd.trim()) return injectHtml(ADSTERRA.lockAd);
  clearGlobals();
  injectHtml(ADSTERRA.socialBar);
  injectHtml(ADSTERRA.popunder);
}

export function bannerDoc(code) {
  return `<!doctype html><html><head><base target="_blank"><style>html,body{margin:0;padding:0;background:transparent;overflow:hidden;display:flex;justify-content:center}</style></head><body>${code}</body></html>`;
}
